// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$("section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
======================
HAMBURGER MENU
======================
*/

	//xl+ sizes the panel to its visible content rather than filling the
	//viewport: the open column is measured separately since it doesn't
	//contribute to column 1's height (flyout, absolutely positioned).
	//Pre-xl the panel is fixed to the full viewport height by CSS instead
	//(see #mobile-navigation, input.css) so this measuring is skipped there.
	function mobileNavColumnHeight($ul) {
		var height = 0;

		$ul.children("li").each(function () {
			height += $(this).outerHeight(true);
		});

		return height + (parseFloat($ul.css("padding-top")) || 0) + (parseFloat($ul.css("padding-bottom")) || 0);
	}

	function updateMobileNavHeight() {
		var $panel = $("#mobile-navigation");

		if (!desktopNav.matches) {
			$panel.css("height", "");
			return;
		}

		var $columns = $panel.find(".navigation > .container-xs > ul")
			.add($panel.find(".navigation li.sub-menu-open > ul.sub-menu"));

		var tallest = 0;
		$columns.each(function () {
			tallest = Math.max(tallest, mobileNavColumnHeight($(this)));
		});

		$panel.css("height", tallest ? (tallest + 60) + "px" : "");
	}

	//pre-xl the panel fills the viewport, so the page behind it is locked.
	//overflow:hidden alone is ignored by iOS Safari for touch scrolling, so the
	//body is pinned with position:fixed at its current offset instead and the
	//scroll position restored on unlock. xl+ is left alone - the mega-menu is
	//content-sized there and the page stays visible beneath it.
	var scrollLockY = null;

	function lockPageScroll() {
		if (scrollLockY !== null) return;
		scrollLockY = window.pageYOffset;
		$("body").css({position: "fixed", top: -scrollLockY + "px", left: 0, right: 0, width: "100%", overflow: "hidden"});
	}

	function unlockPageScroll() {
		if (scrollLockY === null) return;
		$("body").css({position: "", top: "", left: "", right: "", width: "", overflow: ""});
		window.scrollTo(0, scrollLockY);
		scrollLockY = null;
	}

	function syncPageScrollLock() {
		if ($("#mobile-navigation").hasClass("active") && !desktopNav.matches) {
			lockPageScroll();
		} else {
			unlockPageScroll();
		}
	}

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
		updateMobileNavHeight();
		syncPageScrollLock();
	});

	//column widths/wraps can change between breakpoints, so re-measure while open
	$(window).on("resize", function () {
		if ($("#mobile-navigation").hasClass("active")) {
			updateMobileNavHeight();
			syncPageScrollLock();
		}
	});

	//build the accordion chevrons: a chevron on each parent link (rotates on
	//open pre-xl only, see input.css), plus a breadcrumb label at the top of
	//each sub-menu column - only shown on xl+, where columns are still a flyout
	$("#mobile-navigation .menu-item-has-children").each(function () {
		var $li = $(this);
		var $link = $li.children("a");
		var label = $link.text();

		$link.append($("<i>", {class: "fa-regular fa-chevron-right menu-chevron", "aria-hidden": "true"}));

		$li.children("ul.sub-menu").prepend(
			$("<li>", {class: "sub-menu-label", "aria-hidden": "true"}).append(
				$("<i>", {class: "fa-regular fa-chevron-left menu-back-icon", "aria-hidden": "true"}),
				$("<span>").text(label)
			)
		);
	});

	//pre-expand the accordion/column trail for the current page so it's visible on open
	$("#mobile-navigation .menu-item-has-children.current-menu-ancestor").addClass("sub-menu-open");

	//xl+ keeps the hover-driven flyout columns; pre-xl uses a tap-to-toggle accordion instead.
	//Touch-capable devices get the tap-to-toggle chevron at xl+ too, since a touchscreen
	//never fires hover - without this, the first tap on a parent item there would just
	//follow its link with no way to reach the sub-menu.
	//Matches the header's own xl breakpoint (header.php) for when it shows the CTA
	//buttons/search icon instead of just the hamburger.
	var desktopNav = window.matchMedia("(min-width: 1340px)");
	var isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

	function openMobileNavColumn($li) {
		$li.siblings("li.menu-item-has-children").removeClass("sub-menu-open")
			.find("li.menu-item-has-children").removeClass("sub-menu-open");

		$li.addClass("sub-menu-open");
		updateMobileNavHeight();
	}

	function closeMobileNavColumn($li) {
		$li.removeClass("sub-menu-open");
		updateMobileNavHeight();
	}

	//xl+ only (guarded by desktopNav.matches below): hovering a parent item
	//opens its flyout column; the link itself still navigates normally.
	//Plain mouseenter/mouseleave closed the column the instant the cursor
	//crossed a sibling row on its way into the open column, so use menuAim
	//(already used for .main-menu below) to track mouse trajectory and only
	//switch/close once that intent is clear.
	//Bound to the top-level list AND every sub-menu column, so a 3rd-level
	//flyout (e.g. About us > Our Story > Our Timeline) can open the same way.
	$("#mobile-navigation .navigation > .container-xs > ul, #mobile-navigation .navigation ul.sub-menu").menuAim({
		exitMenu: function () {
			return true;
		},
		activate: function (row) {
			var $row = $(row);
			if (desktopNav.matches && $row.hasClass("menu-item-has-children")) {
				openMobileNavColumn($row);
			}
		},
		deactivate: function (row) {
			var $row = $(row);
			if (desktopNav.matches && $row.hasClass("menu-item-has-children")) {
				closeMobileNavColumn($row);
			}
		},
	});

	//pre-xl (no hover at all), and xl+ on touch-capable devices (hover never fires):
	//the chevron expands/collapses a parent item's accordion/flyout section, closing
	//any open sibling - the rest of the row still follows its link as a normal tap.
	//xl+ on non-touch devices skips this - the existing hover-driven flyout (menuAim,
	//above) already handles it there. stopPropagation keeps the tap from also being
	//handled as a click on the wrapping <a> (the chevron sits inside it), which would
	//otherwise still navigate.
	$("#mobile-navigation .navigation").on("click", "li.menu-item-has-children > a > .menu-chevron", function (e) {
		if (desktopNav.matches && !isTouchDevice) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		var $li = $(this).closest("li");
		var wasOpen = $li.hasClass("sub-menu-open");

		if (wasOpen) {
			closeMobileNavColumn($li);
		} else {
			openMobileNavColumn($li);
		}
	});

	//hover class
	$("#header-navigation ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu ul li a.hover").removeClass("hover");
	});

	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}


	/*
=================================
FANCYBOX
=================================
*/


	$("[data-fancybox]").fancybox({
		autoFocus: false,
		touch: false,
		compact: false,
		beforeShow: function () {
			$("html").addClass("fancybox-opened");
			$("body").css("overflow", "hidden");
		},
		afterClose: function () {
			$("html").removeClass("fancybox-opened");
			$("body").css("overflow", "");
		},
	});

	// Prevent clicking from causing a scroll
	$("[data-fancybox]").on("click", function (e) {
		e.preventDefault();
	});


	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	/*if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}*/

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[data-fancybox]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 0,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

	$(".accordion-item .toggle-header").on("click", function () {
		$(this).parent(".accordion-item").toggleClass("active");
		$(this).next(".toggle-content").slideToggle("slow");
	});

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==========================
SLIDERS
==========================
*/

	$(".swiper-wrap").each(function (index, element) {
		var $this = $(element);

		// Find elements inside this swiper-wrap only
		var swiperEl     = $this.find(".swiper")[0];
		var nextBtn      = $this.find(".swiper-button-next")[0];
		var prevBtn      = $this.find(".swiper-button-prev")[0];
		var paginationEl = $this.find(".swiper-pag")[0];

		// Create a new swiper tied to this wrapper
		new Swiper(swiperEl, {
			slidesPerView: 1,
			autoplay: false,
			loop: false,
			spaceBetween: 30,
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		});
	});

	//Small Image slider
	var swiper2 = new Swiper(".swiper-6-slides .swiper", {
		slidesPerView: 3,
		spaceBetween: 10,
		navigation: {
			nextEl: ".swiper-6-slides .swiper-button-next",
			prevEl: ".swiper-6-slides .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-6-slides .swiper-pag",
			clickable: true,
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 50,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 70,
			},
			1600: {
				slidesPerView: 6,
				spaceBetween: 100,
			},
		},
	});

	//Large Slider - Full
	$(".swiper-full").each(function() {
        var $full = $(this);

        // Initialize Swiper on the child .swiper element
        new Swiper($full.find(".swiper")[0], {
            spaceBetween: 0,
            slidesPerView: 1,
            autoplay: false,
            loop: false,
            navigation: {
                nextEl: $full.find(".swiper-button-next")[0],
                prevEl: $full.find(".swiper-button-prev")[0],
            },
            pagination: {
                el: $full.find(".swiper-pag")[0],
                clickable: true,
            },
        });
    });

	//Timeline - free-scrolling, draggable strip of milestones that bleeds off the right edge
	$(".timeline-swiper").each(function () {
		var $timeline = $(this);

		new Swiper($timeline.find(".swiper")[0], {
			slidesPerView: "auto",
			spaceBetween: 40,
			freeMode: true,
			grabCursor: true,
			navigation: {
				nextEl: $timeline.find(".timeline-nav-next")[0],
				prevEl: $timeline.find(".timeline-nav-prev")[0],
			},
			pagination: {
				el: $timeline.find(".timeline-pagination")[0],
				clickable: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 60,
				},
				1200: {
					spaceBetween: 90,
				},
			},
		});
	});

	//Overflow Canvas - free-scrolling, draggable strip for a single super-wide image that bleeds off the right edge
	$(".overflow-canvas-swiper").each(function () {
		var $canvas = $(this);
		var $prev = $canvas.find(".overflow-canvas-nav-prev");
		var $next = $canvas.find(".overflow-canvas-nav-next");
		var $dots = $canvas.find(".overflow-canvas-dot");

		//Pagination is a single slide being panned rather than a real set of slides, so Swiper's own
		//per-slide pagination has nothing to count - the two dots are driven manually from scroll progress instead
		var canvasSwiper = new Swiper($canvas.find(".swiper")[0], {
			slidesPerView: "auto",
			freeMode: true,
			grabCursor: true,
			mousewheel: {
				forceToAxis: true,
			},
			on: {
				progress: function () {
					$prev.prop("disabled", this.isBeginning);
					$next.prop("disabled", this.isEnd);
					$dots.removeClass("overflow-canvas-dot-active").eq(this.progress < 0.5 ? 0 : 1).addClass("overflow-canvas-dot-active");
				},
			},
		});

		//Buttons pan the translate directly rather than stepping between slides, since this is a single image rather than a set of slides
		$prev.on("click", function () {
			var panAmount = canvasSwiper.width * 0.8;
			canvasSwiper.translateTo(Math.min(canvasSwiper.translate + panAmount, canvasSwiper.minTranslate()), 300);
		});

		$next.on("click", function () {
			var panAmount = canvasSwiper.width * 0.8;
			canvasSwiper.translateTo(Math.max(canvasSwiper.translate - panAmount, canvasSwiper.maxTranslate()), 300);
		});
	});

	//Banner Slider
	var swiper1 = new Swiper(".banner-slider .swiper", {
		autoplay: true,
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: false,
	});

	//Logos - continuous ticker on mobile + tablet (desktop keeps the static grid markup instead).
	//Built/destroyed on breakpoint change rather than left running hidden, since Swiper
	//measures slide widths off the DOM and .logos-swiper is display:none at xl+.
	var logosMobile = window.matchMedia("(max-width: 1339px)");
	var logosSwiper = null;

	function initLogosSwiper() {
		if (logosSwiper) return;
		$(".logos-swiper").each(function () {
			logosSwiper = new Swiper($(this).find(".swiper")[0], {
				slidesPerView: "auto",
				loop: true,
				speed: 4000,
				spaceBetween: 0,
				allowTouchMove: true,
				grabCursor: true,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
				},
			});
		});
	}

	function destroyLogosSwiper() {
		if (!logosSwiper) return;
		logosSwiper.destroy(true, true);
		logosSwiper = null;
	}

	function syncLogosSwiper() {
		if (logosMobile.matches) {
			initLogosSwiper();
		} else {
			destroyLogosSwiper();
		}
	}

	syncLogosSwiper();
	logosMobile.addEventListener("change", syncLogosSwiper);

	//Systems grid - single full-width slide with the next card peeking in on mobile/tablet
	//(static grid markup takes over at xxl+ instead). Built/destroyed per-instance on
	//breakpoint change, same reasoning as the Logos ticker above.
	var systemsMobile = window.matchMedia("(max-width: 1399px)");

	function syncSystemsSwiper() {
		$(".systems-grid-swiper").each(function () {
			var $wrap = $(this);
			var instance = $wrap.data("swiper-instance");

			if (systemsMobile.matches) {
				if (instance) return;

				instance = new Swiper($wrap.find(".swiper")[0], {
					slidesPerView: 1.15,
					spaceBetween: 16,
					navigation: {
						nextEl: $wrap.find(".systems-nav-next")[0],
						prevEl: $wrap.find(".systems-nav-prev")[0],
					},
					pagination: {
						el: $wrap.find(".systems-pagination")[0],
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: 2.15,
							spaceBetween: 24,
						},
					},
				});
				$wrap.data("swiper-instance", instance);
			} else if (instance) {
				instance.destroy(true, true);
				$wrap.data("swiper-instance", null);
			}
		});
	}

	syncSystemsSwiper();
	systemsMobile.addEventListener("change", syncSystemsSwiper);

	//Team grid - single full-width slide with the next member peeking in on mobile/tablet
	//(static grid markup takes over at xl+ instead). Built/destroyed per-instance on
	//breakpoint change, same pattern as the Systems grid above.
	var teamMobile = window.matchMedia("(max-width: 1339px)");

	function syncTeamSwiper() {
		$(".team-grid-swiper").each(function () {
			var $wrap = $(this);
			var instance = $wrap.data("swiper-instance");

			if (teamMobile.matches) {
				if (instance) return;

				instance = new Swiper($wrap.find(".swiper")[0], {
					slidesPerView: 1.15,
					spaceBetween: 16,
					navigation: {
						nextEl: $wrap.find(".team-nav-next")[0],
						prevEl: $wrap.find(".team-nav-prev")[0],
					},
					pagination: {
						el: $wrap.find(".team-pagination")[0],
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: 2.15,
							spaceBetween: 24,
						},
					},
				});
				$wrap.data("swiper-instance", instance);
			} else if (instance) {
				instance.destroy(true, true);
				$wrap.data("swiper-instance", null);
			}
		});
	}

	syncTeamSwiper();
	teamMobile.addEventListener("change", syncTeamSwiper);

	//Featured posts grid - single full-width slide with the next card peeking in on mobile/tablet
	//(static grid markup takes over at xl+ instead). Built/destroyed per-instance on
	//breakpoint change, same pattern as the Systems/Team grids above.
	var featuredPostsMobile = window.matchMedia("(max-width: 1339px)");

	function syncFeaturedPostsSwiper() {
		$(".featured-posts-grid-swiper").each(function () {
			var $wrap = $(this);
			var instance = $wrap.data("swiper-instance");

			if (featuredPostsMobile.matches) {
				if (instance) return;

				instance = new Swiper($wrap.find(".swiper")[0], {
					slidesPerView: 1.15,
					spaceBetween: 16,
					navigation: {
						nextEl: $wrap.find(".featured-posts-nav-next")[0],
						prevEl: $wrap.find(".featured-posts-nav-prev")[0],
					},
					pagination: {
						el: $wrap.find(".featured-posts-pagination")[0],
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: 2.15,
							spaceBetween: 24,
						},
					},
				});
				$wrap.data("swiper-instance", instance);
			} else if (instance) {
				instance.destroy(true, true);
				$wrap.data("swiper-instance", null);
			}
		});
	}

	syncFeaturedPostsSwiper();
	featuredPostsMobile.addEventListener("change", syncFeaturedPostsSwiper);

	//Featured pages grid - single full-width slide with the next card peeking in on mobile/tablet
	//(static grid markup takes over at xl+ instead). Built/destroyed per-instance on
	//breakpoint change, same pattern as the Systems/Team/Featured posts grids above.
	var featuredPagesMobile = window.matchMedia("(max-width: 1339px)");

	function syncFeaturedPagesSwiper() {
		$(".featured-pages-grid-swiper").each(function () {
			var $wrap = $(this);
			var instance = $wrap.data("swiper-instance");

			if (featuredPagesMobile.matches) {
				if (instance) return;

				instance = new Swiper($wrap.find(".swiper")[0], {
					slidesPerView: 1.15,
					spaceBetween: 16,
					navigation: {
						nextEl: $wrap.find(".featured-pages-nav-next")[0],
						prevEl: $wrap.find(".featured-pages-nav-prev")[0],
					},
					pagination: {
						el: $wrap.find(".featured-pages-pagination")[0],
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: 2.15,
							spaceBetween: 24,
						},
					},
				});
				$wrap.data("swiper-instance", instance);
			} else if (instance) {
				instance.destroy(true, true);
				$wrap.data("swiper-instance", null);
			}
		});
	}

	syncFeaturedPagesSwiper();
	featuredPagesMobile.addEventListener("change", syncFeaturedPagesSwiper);


	//Large Image Slider
	/*var swiper3 = new Swiper(".mySwiper3", {
		spaceBetween: 20,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".large-image-slider .swiper-button-next",
			prevEl: ".large-image-slider .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-2",
		},
		breakpoints: {
			900: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
	});

	//reviews carousel
	var swiper2 = new Swiper(".reviews-carousel", {
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: false,
		centeredSlidesBounds: false,
		loop: true,
		navigation: {
			nextEl: ".reviews-carousel .swiper-button-next",
			prevEl: ".reviews-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".reviews-carousel .swiper-pagination",
		},
		breakpoints: {
			680: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			850: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});

	//Single Page Related Content
	var swiper5 = new Swiper(".related__swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: ".reviews .swiper-button-next",
			prevEl: ".reviews .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-4",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});*/

	/*
===========================
MATCH HEIGHTS
===========================
*/

	$(function () {
		$(".news-block h3.block-title").matchHeight({property: "height"});
	});


	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});

	/*
=================================
LARGE IMAGE BLOCKS WITH DIGITS
=================================
*/

	//.digit-image and .digit-blocks are sized against different max-width systems
	//(the image bleeds against .bleed-container, the digits sit inside the narrower,
	//breakpoint-capped .container), so a fixed calc() width on the image drifts out of
	//sync with the digits and can overlap them. Measure the live gap instead so the
	//image always stops a fixed distance short of .digit-blocks, whatever the viewport
	//or content width. Note: .digit-container itself is full-width (justify-end only
	//shifts its .digit-blocks child rightward), so .digit-blocks - not .digit-container -
	//is the element whose left edge marks where the numbers actually start.
	//
	//Below xl (1340px, matching the same breakpoint the CSS uses to switch this layout
	//from stacked to side-by-side) the image is just a full-width banner in normal flow,
	//so any inline width left over from a wider viewport needs clearing rather than measured.
	var digitImageDesktop = window.matchMedia("(min-width: 1340px)");

	function sizeDigitImages() {
		var gap = 60;

		$(".large-image-blocks-digits .digit-panel").each(function () {
			var $panel = $(this);
			var $image = $panel.find(".digit-image").first();
			var $digitBlocks = $panel.find(".digit-blocks").first();

			if (!$image.length || !$digitBlocks.length) {
				return;
			}

			if (!digitImageDesktop.matches) {
				$image.css("width", "");
				return;
			}

			var width = $digitBlocks[0].getBoundingClientRect().left - $panel[0].getBoundingClientRect().left - gap;

			$image.css("width", Math.max(width, 0) + "px");
		});
	}

	sizeDigitImages();
	$(window).on("load", sizeDigitImages);
	$(window).on("resize", sizeDigitImages);

	if (window.ResizeObserver) {
		var digitResizeObserver = new ResizeObserver(sizeDigitImages);
		document.querySelectorAll(".large-image-blocks-digits .digit-blocks").forEach(function (el) {
			digitResizeObserver.observe(el);
		});
	}

	/*
=================================
DIGIT COUNT UP
=================================
Shared by any layout that renders a .digit-number[data-count-to] - currently
large-image-blocks-digits and content-and-digits.
*/

	// Animates each .digit-number from 0 up to its data-count-to value the first time it
	// scrolls into view, with a short opacity fade so the count doesn't just pop into
	// existence. The server-rendered text (final formatted number + symbol) is the
	// no-JS/first-paint fallback, so this only needs to run for browsers that support
	// IntersectionObserver - anything older just keeps showing the static fallback.
	var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	function animateDigitNumber($number) {
		var target = parseFloat($number.attr("data-count-to"));
		var symbol = $number.attr("data-count-symbol") || "";

		if (isNaN(target)) {
			return;
		}

		$number.css("opacity", 1);

		if (prefersReducedMotion) {
			$number.text(target.toLocaleString() + symbol);
			return;
		}

		// Snap the displayed value to chunks rather than every single integer - counting
		// 1,497...1,498...1,499...1,500 one-by-one reads as jittery, whereas landing on
		// ~30 evenly-spaced values on the way up feels like a smooth, deliberate count.
		var displayStep = Math.max(1, Math.round(target / 30));

		$({count: 0}).animate(
			{count: target},
			{
				duration: 1600,
				easing: "swing",
				step: function (now) {
					var snapped = Math.min(Math.round(now / displayStep) * displayStep, target);
					$number.text(snapped.toLocaleString() + symbol);
				},
				complete: function () {
					$number.text(target.toLocaleString() + symbol);
				},
			}
		);
	}

	if (window.IntersectionObserver) {
		var $digitNumbers = $(".large-image-blocks-digits .digit-number[data-count-to], .content-and-digits .digit-number[data-count-to]");

		$digitNumbers.css({
			opacity: 0,
			transition: "opacity 300ms ease-out",
		});

		var digitNumberObserver = new IntersectionObserver(
			function (entries, observer) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						animateDigitNumber($(entry.target));
						observer.unobserve(entry.target);
					}
				});
			},
			{threshold: 0.5}
		);

		$digitNumbers.each(function () {
			digitNumberObserver.observe(this);
		});
	}

	/*
=================================
FEATURE INTRO BACKDROP
=================================
*/

	//.feature-intro-backdrop bleeds .feature-intro's background to the true left (or, for
	//.feature-intro-backdrop--right panels such as alternating product-category-block terms,
	//right) viewport edge against .bleed-container while .feature-grid stays inside the
	//narrower, breakpoint-capped .container - same drifting-max-width problem as the digit
	//image above, so it gets the same live-measurement fix: size the backdrop to stop a fixed
	//15px short of .feature-grid, whatever the viewport width. Skipped below lg, where
	//the backdrop is hidden and the layout stacks instead. Selector is untargeted by section
	//class (.feature-panel is only ever used for this bleed pattern - system-block.php,
	//product-category-block.php, content_left_and_4_feature_blocks_right.php and
	//single-system.php's 6-image layout all share it) so any new bleeding panel picks this up
	//for free. Above 2000px the inline width is removed entirely so the backdrop falls back
	//to its CSS sizing.
	var featureIntroBackdropWide = window.matchMedia("(min-width: 2001px)");

	function sizeFeatureIntroBackdrop() {
		var gap = 15;

		$(".feature-panel").each(function () {
			var $panel = $(this);
			var $backdrop = $panel.find(".feature-intro-backdrop").first();
			var $featureGrid = $panel.find(".feature-grid").first();

			if (featureIntroBackdropWide.matches) {
				$backdrop.css("width", "");
				return;
			}

			if (!$backdrop.length || !$featureGrid.length || !$backdrop.is(":visible")) {
				return;
			}

			var panelRect = $panel[0].getBoundingClientRect();
			var gridRect = $featureGrid[0].getBoundingClientRect();
			var isBleedRight = $backdrop.hasClass("feature-intro-backdrop--right");

			var width = isBleedRight
				? panelRect.right - gridRect.right - gap
				: gridRect.left - panelRect.left - gap;

			$backdrop.css("width", Math.max(width, 0) + "px");
		});
	}

	sizeFeatureIntroBackdrop();
	$(window).on("load", sizeFeatureIntroBackdrop);
	$(window).on("resize", sizeFeatureIntroBackdrop);

	if (window.ResizeObserver) {
		var featureGridResizeObserver = new ResizeObserver(sizeFeatureIntroBackdrop);
		document.querySelectorAll(".feature-panel .feature-grid").forEach(function (el) {
			featureGridResizeObserver.observe(el);
		});
	}

	/*
=================================
SHRINK OVERSIZED TEXT TO FIT
=================================
Shared by anything whose font-size is otherwise a fixed value that can be too
big for its content: the image-banner heading (banner-image.php - single
system names, but also market-category/archive/case-study titles etc, all
of which vary a lot in length), the system-card name in the "systems (no
image)" layout, the market sector tile heading (market_sectors.php), and the
"Decorated System Name" heading in the system-block feature-intro panel,
plus the "H2 Has Big Word" TinyMCE style (editors apply it site-wide, on
arbitrary tags - see the format list in wysiwyg-formats.php - to make a
short phrase display-sized). None of these are forced onto one
line - normal wrapping is left alone, and each matched element's rendered
width is only checked against its parent's (font-size scaled down just
enough to stop it overflowing) when an unbreakable word can't wrap and
overflows anyway; otherwise the inline override is cleared so the element's
normal CSS size (the custom-h1 clamp, the 40px H2-has-big-word rule, etc.)
applies untouched.
*/

	var shrinkToFitMobile = window.matchMedia("(max-width: 550px)");

	//Same "below lg" cutoff as the other tablet+mobile matchMedia checks in this
	//file (logosMobile, systemsMobile, etc.) - the post-banner heading's fixed
	//xxl:text-[90px] size only kicks in at 1400px, so everything below lg is
	//still on the fluid custom-h1 clamp (up to 120px) and can overflow on
	//longer post titles well before the 550px cutoff above.
	var shrinkToFitTabletMobile = window.matchMedia("(max-width: 1023px)");

	function shrinkToFitWidth($el, opts) {
		opts = opts || {};

		var query = opts.query || shrinkToFitMobile;

		//most of these fixed sizes are only oversized on narrow (mobile) viewports,
		//but the system-card name's own container width varies by breakpoint
		//regardless of viewport size (mobile swiper slide vs the lg 4-column grid),
		//so that one needs fitting checked at every size
		var active = opts.always || query.matches;

		if (!active) {
			$el.css("font-size", "");
			return;
		}

		//reset to the natural (CSS-defined) size before measuring, so resize/
		//orientation changes re-fit from scratch rather than compounding
		$el.css("font-size", "");

		var available = $el.parent()[0].getBoundingClientRect().width;
		var natural = $el[0].scrollWidth;

		if (natural > available) {
			var currentSize = parseFloat($el.css("font-size"));
			//small buffer so rounding doesn't leave it juuust overflowing
			$el.css("font-size", Math.floor(currentSize * (available / natural) * 0.98) + "px");
		}
	}

	//Image banner heading (banner-image.php) - covers the single-system hero as
	//well as every other page that uses this banner type (archives, market
	//categories, etc.).
	function fitImageBannerHeading() {
		$(".image-banner .banner-content h1").each(function () {
			shrinkToFitWidth($(this));
		});
	}

	//Post banner heading (banner-single.php) - post titles vary a lot in length
	//and only get a fixed size (xxl:text-[90px]) at 1400px+; below that they're
	//on the fluid custom-h1 clamp, so shrink to fit on tablet and mobile rather
	//than the mobile-only cutoff used above.
	function fitPostBannerHeading() {
		$(".post-banner .banner-content h1").each(function () {
			shrinkToFitWidth($(this), {query: shrinkToFitTabletMobile});
		});
	}

	//"H2 Has Big Word" WYSIWYG style - used on arbitrary tags including
	//multi-word paragraphs/lists, so wrapping is left alone; only shrunk when
	//an unbreakable word within it actually overflows.
	function fitBigWordText() {
		$(".h2-has-big-word").each(function () {
			shrinkToFitWidth($(this));
		});
	}

	//"Decorated System Name" heading in the system-block feature-intro panel -
	//same system-name-length problem as the banner heading above.
	function fitDecoratedSystemName() {
		$(".content-left-and-4-feature-blocks-right .feature-intro .decorated-system-name").each(function () {
			shrinkToFitWidth($(this));
		});
	}

	//System card name in the "systems (no image)" layout - the font-size utility
	//(systems_no_image.php) targets the WYSIWYG's own tag (h2-h6/p), not the
	//wrapping div, so each of those is sized individually rather than the
	//wrapper as a whole. Runs at every breakpoint (see shrinkToFitWidth above).
	function fitSystemCardName() {
		$(".system-card-name > div").find("h2, h3, h4, h5, h6, p").each(function () {
			shrinkToFitWidth($(this), {always: true});
		});
	}

	//Market sector tile heading (market_sectors.php) - fixed text-[40px] (with
	//an sm:text-[28px] step down) is sized for the widest (lg, 4-column) tile,
	//so a long single word/short phrase can overflow the tile's own padding at
	//other grid widths (1-column mobile, 2-column sm) regardless of viewport
	//breakpoint - same "container width isn't tied to a viewport cutoff"
	//situation as the system-card name above, so this also runs at every size.
	function fitMarketTileHeading() {
		$(".market-tile-heading").each(function () {
			shrinkToFitWidth($(this), {always: true});
		});
	}

	function shrinkOversizedTextToFit() {
		fitImageBannerHeading();
		fitPostBannerHeading();
		fitBigWordText();
		fitDecoratedSystemName();
		fitSystemCardName();
		fitMarketTileHeading();
	}

	shrinkOversizedTextToFit();
	$(window).on("load", shrinkOversizedTextToFit);
	$(window).on("resize", shrinkOversizedTextToFit);

	if (window.ResizeObserver) {
		var shrinkToFitResizeObserver = new ResizeObserver(shrinkOversizedTextToFit);

		document.querySelectorAll(".image-banner .banner-content").forEach(function (el) {
			shrinkToFitResizeObserver.observe(el);
		});

		document.querySelectorAll(".post-banner .banner-content").forEach(function (el) {
			shrinkToFitResizeObserver.observe(el);
		});

		document.querySelectorAll(".content-left-and-4-feature-blocks-right .feature-intro .decorated-system-name").forEach(function (el) {
			if (el.parentElement) {
				shrinkToFitResizeObserver.observe(el.parentElement);
			}
		});

		document.querySelectorAll(".system-card-name > div").forEach(function (el) {
			shrinkToFitResizeObserver.observe(el);
		});

		document.querySelectorAll(".market-tile-heading").forEach(function (el) {
			shrinkToFitResizeObserver.observe(el);
		});
	}

	/*
==========================
PRODUCT GALLERY
==========================
*/

	$(".product-banner-gallery-thumb").on("click", function () {
		var $thumb = $(this);
		var $gallery = $thumb.closest(".product-banner-gallery");
		var index = $thumb.data("gallery-thumb");

		$gallery.find(".product-banner-gallery-thumb").removeClass("border-primary").addClass("border-transparent");
		$thumb.removeClass("border-transparent").addClass("border-primary");

		$gallery.find(".product-banner-gallery-image").addClass("hidden");
		$gallery.find(".product-banner-gallery-image[data-gallery-image='" + index + "']").removeClass("hidden");
	});

	/*
==========================
AJAX
==========================
*/

	//LOAD MORE POSTS
	$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});
}); //end document.ready
